<script setup lang="ts">
import type { ListboxGroupProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { ListboxGroup, ListboxGroupLabel, useId } from 'reka-ui';
import { computed, onMounted, onUnmounted } from 'vue';
import { cn } from '@/lib/utils';
import { provideCommandGroupContext, useCommand } from '.';

const props = defineProps<
  ListboxGroupProps & {
    class?: HTMLAttributes['class'];
    heading?: string;
  }
>();

const delegatedProps = reactiveOmit(props, 'class');

const { allGroups, filterState, disableFilter } = useCommand();
const id = useId();

const isRender = computed(() =>
  !filterState.search || disableFilter ? true : filterState.filtered.groups.has(id)
);

provideCommandGroupContext({ id });
onMounted(() => {
  if (!allGroups.value.has(id)) allGroups.value.set(id, new Set());
});
onUnmounted(() => {
  allGroups.value.delete(id);
});
</script>

<template>
  <ListboxGroup
    v-bind="delegatedProps"
    :id="id"
    :class="
      cn(
        'tw-overflow-hidden tw-p-1 tw-text-neutral-950 [&_[cmdk-group-heading]]:tw-px-2 [&_[cmdk-group-heading]]:tw-py-1.5 [&_[cmdk-group-heading]]:tw-text-xs [&_[cmdk-group-heading]]:tw-font-medium [&_[cmdk-group-heading]]:tw-text-neutral-500 dark:tw-text-neutral-50 dark:[&_[cmdk-group-heading]]:tw-text-neutral-400',
        props.class
      )
    "
    :hidden="isRender ? undefined : true"
  >
    <ListboxGroupLabel
      v-if="heading"
      class="tw-px-2 tw-py-1.5 tw-text-xs tw-font-medium tw-text-neutral-500 dark:tw-text-neutral-400"
    >
      {{ heading }}
    </ListboxGroupLabel>
    <slot />
  </ListboxGroup>
</template>
